function initIndria(scope=document){
  scope.querySelectorAll('[data-product-root]').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    const input=root.querySelector('[name="id"]');
    const add=root.querySelector('[data-add]');
    const price=root.querySelector('[data-price]');
    const message=root.querySelector('[data-variant-message]');
    const selects=[...root.querySelectorAll('[data-option]')];
    const money=v=>new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:root.dataset.currency}).format(v/100);
    function update(){
      const chosen=selects.map(select=>select.value);
      const variant=variants.find(v=>v.options.every((o,i)=>o===chosen[i]));
      input.value=variant?variant.id:'';
      input.disabled=!variant;
      add.disabled=!variant||!variant.available;
      add.textContent=!variant?root.dataset.unavailable:variant.available?root.dataset.add:root.dataset.sold;
      message.textContent=!variant?root.dataset.unavailable:variant.available?'':root.dataset.sold;
      if(variant){
        price.textContent=money(variant.price);
        const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
        if(variant.featured_image){const img=root.querySelector('[data-main-image]');if(img){img.src=variant.featured_image.src;img.removeAttribute('srcset');img.alt=variant.featured_image.alt||root.dataset.title;}}
      }
    }
    selects.forEach(select=>select.addEventListener('change',update));
  });
}
document.addEventListener('DOMContentLoaded',()=>initIndria());
document.addEventListener('shopify:section:load',event=>initIndria(event.target));
